<div class="wizard-step-container">
  <div class="wizard-step-header">
    <h1 class="wizard-step-title" role="heading" aria-level="1">{{title}}</h1>
    <p class="wizard-step-subtitle" role="heading" aria-level="2">
      <span *ngIf="isEnglish">{{subtitleBeginning}}<strong>{{subtitleMiddle}}</strong>{{subtitleEnd}}</span>
      <span *ngIf="!isEnglish">{{i18nSubtitle}}</span>
    </p>
  </div>
  <fieldset [attr.aria-label]="title">
    <div *ngIf="primaryUse === 'Education'" class="columns is-multiline is-mobile is-centered is-gapless wizard-tile-wrapper-container">
      <div *ngFor="let useCaseOption of useCaseOptions; index as i" class="column is-full-mobile is-3-tablet is-2-desktop">
        <app-wizard-tile
          [selectionType]="'radio'"
          [currentStepName]="analyticsStepName"
          [wizardOption]="useCaseOption"
          [isSelected]="useCaseOption.isSelected"
          [isAlignTextLeft]="true"
          [removeBottomPadding]="false"
          (onSelectEvent)="onSelect($event)">
        </app-wizard-tile>
      </div>
    </div>
    <div *ngIf="primaryUse !== 'Education'" class="columns is-multiline is-mobile is-centered is-gapless wizard-tile-wrapper-container">
      <div *ngFor="let useCaseOption of useCaseOptions; index as i" class="column">
        <app-wizard-tile
          [selectionType]="'radio'"
          [currentStepName]="analyticsStepName"
          [wizardOption]="useCaseOption"
          [isSelected]="useCaseOption.isSelected"
          [isAlignTextLeft]="true"
          (onSelectEvent)="onSelect($event)">
        </app-wizard-tile>
      </div>
    </div>
  </fieldset>
  </div>
  
<div class="bottom-nav-items">
  <app-wizard-navigation
    [currentStepName]="analyticsStepName"
    [currentStepNumber]="stepNumber"
    [disableContinueButton]="isContinueBtnDisabled"
    [previousStepRoute]="'/primary-use'"
    [nextStepRoute]="'/need-to-run'"
    [hasSkipButton]="true"
    (onSkipPressed)="onSkip()">
  </app-wizard-navigation>

   <app-progress-bar [step]="currentStep" [stepNumber]="stepNumber"></app-progress-bar>
</div>